import { render, staticRenderFns } from "./IconQuantityLow.vue?vue&type=template&id=42a6c4f6&scoped=true"
import script from "./IconQuantityLow.vue?vue&type=script&lang=js"
export * from "./IconQuantityLow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a6c4f6",
  null
  
)

export default component.exports